import { useAuth } from '../contexts/AuthContext';
import { useNavigate, NavLink } from 'react-router-dom';
import { route } from '../globals/constants';

function AdminLayout({ children }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };



    return (
        <div className="admin-wrapper">
            {/* Sidebar */}
            <div className="admin-sidebar">
                <div className="admin-sidebar-header">
                    <h3 className="site-text-primary">EZ Storage and Warehousing</h3>
                    <p className="text-muted">Admin Panel</p>
                </div>
                
                <nav className="admin-sidebar-nav">
                    <ul>
                        <li>
                            <NavLink 
                                to={route.admin.MESSAGES}
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                <i className="fa fa-envelope" /> Messages
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={route.admin.BLOG_LIST}
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                <i className="fa fa-file-alt" /> Blogs
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={route.admin.GALLERY_MANAGE}
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                <i className="fa fa-upload" /> Add Gallery Item
                            </NavLink>
                        </li>
                        <li>
                            <button 
                                type="button" 
                                onClick={() => {}}
                                style={{ 
                                    background: 'none', 
                                    border: 'none', 
                                    color: 'inherit', 
                                    cursor: 'pointer',
                                    width: '100%',
                                    textAlign: 'left',
                                    padding: '10px 20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}
                            >
                                <i className="fa fa-users" /> Users
                            </button>
                        </li>
                        <li>
                            <button 
                                type="button" 
                                onClick={() => {}}
                                style={{ 
                                    background: 'none', 
                                    border: 'none', 
                                    color: 'inherit', 
                                    cursor: 'pointer',
                                    width: '100%',
                                    textAlign: 'left',
                                    padding: '10px 20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}
                            >
                                <i className="fa fa-cog" /> Settings
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            {/* Main Content Area */}
            <div className="admin-main">
                {/* Header */}
                <div className="admin-header">
                    <div className="admin-header-left">
                        <h4>Admin Panel</h4>
                    </div>
                    <div className="admin-header-right">
                        <span className="admin-user-info">
                            <i className="fa fa-user" /> {user?.username}
                        </span>
                        <button 
                            onClick={handleLogout}
                            className="site-button-secondry"
                            style={{ marginLeft: '15px' }}
                        >
                            <i className="fa fa-sign-out" /> Logout
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="admin-content">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AdminLayout;

